"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-12-17 10:21:21
 * @LastEditTime: 2021-12-20 10:21:50
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\render\Heatmap.ts
 */
exports.default = {
    // data: data.map(function (item) {
    //   return [item[1], item[0], item[2] || '-'];
    // }),
    label: {
        fontSize: 12,
        emphasis: {
            show: true
        }
    },
    itemStyle: {
        borderColor: "#fff",
        borderWitdh: 1
    }
};
//# sourceMappingURL=Heatmap.js.map